import { React, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import "react-datepicker/dist/react-datepicker.css";
import {
  isEndDateGreater, changeDateFormat
} from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { API_URL } from '../../../../Constant';
import messages from '../../../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import { getUrbanRegionalGeneralIndexReport } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';

const RuralRegionalGeneralIndex = () => {
  const token = useContext(MyContextProvider).token;
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [reportType, setReportType] = useState('');
  const [groupType, setGroupType] = useState('');
  const storedLanguage = localStorage.getItem('language');
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };


  //Hamndle Onchange 
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "fromDate":
        setFromDate(value);
        break;
      case "toDate":
        setToDate(value);
        break;
      case "report_type":
        setReportType(value);
        break;
      case "group_type":
        setGroupType(value);
        break;
      default:
        console.log("Case is not match")
    }

  }

  const greateDateFunction = (startDate, endDate) => {
    const sDate = new Date(startDate);
    const eDate = new Date(endDate);
    // Check if endDate is greater than startDate
    return eDate > sDate;
  }

  //handle excel sheet ***************
  const handleGenerateExcel = async () => {

    if (!fromDate || !toDate) {
      toast.error('Please select the Year range', messages.COLOR_RED);
      return;
    }
    if (!greateDateFunction(fromDate, toDate)) {
      toast.error("From Year Greater Than To Year", messages.COLOR_RED);
      return;
    }

    if (reportType === '') {
      toast.error('Please select Report Type', messages.COLOR_RED);
      return
    }
    if (groupType === '') {
      toast.error('Please select Group Type', messages.COLOR_RED);
      return
    }

    try {
      showLoading(true);
      let post_data = {
        fromYearDate: fromDate,
        toYearDate: toDate,
        reportType: reportType,
        groupType: groupType
      }
      const response = await axios.post(`${API_URL}api/price/RuralRegionIndexReports`, post_data, config);
      const reportData = response.data;
      if (reportData.status) {
        let allData = reportData.data.GroupCodes;
        downloadReport(allData, reportType, groupType)

      } else {
        toast.error('Data is not found', messages.COLOR_RED);

      }
    } catch (error) {
      console.error(error);

    } finally {
      showLoading(false);
    }
  }





  const downloadReport = (allData, reportType, groupType) => {

    let transformedData = [];

    if (groupType === 'Major Group') {
      transformedData = allData.map(item => [
        item.reportYear,
        item.index_state, // General Index (state level)
        item.major1,       // First major group
        item.major2,       // Second major group
        item.major3,       // Third major group
        item.major4,       // Fourth major group
        item.major5        // Fifth major group
      ]);
    } else {
      transformedData = allData.map(item => [
        item.year,
        item.index_state,   // General Index (state level)
        item.index_west,    // Western region
        item.index_central, // Central region
        item.index_bundelkhand, // Bundelkhand region
        item.index_east,    // Eastern region
        item.reportYear
      ]);
    }

    let FirstHeaderHindiColumns = [];
    let headerHindiColumns = [];
    let headerEnglishColumns = [];
    if (groupType === 'All') { //Region Wise

      FirstHeaderHindiColumns = ['अवधि', 'राज्य', 'क्षेत्र  Region', '', '', '', 'Period']
      headerHindiColumns = ['', '', 'पश्चिमी', 'मध्य', 'बुंदेलखंड', 'पूर्वी', '']

      if (reportType === 'Agriculture Year') {
        headerEnglishColumns = ['कृषि वर्ष', 'State', 'Western', 'Central', 'Bundelkhand', 'Eastern', 'Agriculture Year']
      }
      if (reportType === 'Financial Year') {
        headerEnglishColumns = ['वित्तीय वर्ष', 'State', 'Western', 'Central', 'Bundelkhand', 'Eastern', 'Financial Year']
      }


    } else if (groupType === 'Major Group') {//Major Group

      if (reportType === 'Agriculture Year') {
        FirstHeaderHindiColumns = ['कृषि वर्षवार', 'समस्त', 'खाद्य, पेय पदार्थ और तंबाकू', 'ईंधन और प्रकाश',
          'आवास', 'वस्त्र ,बिस्तर एवं जूते', 'विविध']
        headerHindiColumns = ['Agriculture Year', 'General Indices', 'Food , Beverages & Tobacco',
          'Fuel & Light ', 'Housing', 'Clothing & Footwear', 'Misc.']
      }
      if (reportType === 'Financial Year') {
        FirstHeaderHindiColumns = ['वित्तीय वर्षवार', 'समस्त', 'खाद्य, पेय पदार्थ और तंबाकू', 'ईंधन और प्रकाश',
          'आवास', 'वस्त्र ,बिस्तर एवं जूते', 'विविध']
        headerHindiColumns = ['Financial Year', 'General Indices', 'Food , Beverages & Tobacco',
          'Fuel & Light ', 'Housing', 'Clothing & Footwear', 'Misc.']
      }



    }
    let heading = (groupType === "All") ? 'Regional General' : ' Major Groupwise';

    const excelObjectData = {
      groupType: groupType,
      fileName: (groupType === "All") ? `RegionwiseGeneralIndexRural(${reportType})` : `MajorGroupGeneralIndexRural(${reportType})`,
      fileType: 'xls',
      sheetName: (groupType === "All") ? 'RegionGeneralIndexReport' : 'MajorGroupIndexReport',
      firstRowMergeCells: 'A1:G1',
      firstRowExportDate: changeDateFormat(new Date()),
      secondRowMergeCells: 'A2:G2',
      secondRowText: `उत्तर प्रदेश की नगरीय उपभोक्ता भाव सूचकांक (आधार  कृषि  वर्ष  2011-12=100)`,
      thirdRowMergeCells: 'A3:G3',
      thirdRowText: `क्षैत्र वार  सामान्य वार्षिक  औषत (कृषि वर्षवार) सूचकांक`,
      fourthRowMergeCells: 'A4:G4',
      fourthRowText: `RURAL CONSUMER PRICE INDEX OF U.P.(Base Agr. Year 2011-12)`,
      fifthRowMergeCells: 'A5:G5',
      fifthRowText: `Annual Average ( ${reportType} Wise ) of ${heading} Indices`,
      FirstHeaderHindiColumns: FirstHeaderHindiColumns,
      headerHindiColumns: headerHindiColumns,
      headerEnglishColumns: headerEnglishColumns,
      excelRowData: transformedData,
    };

    excelObjectData.excelRowData = transformedData;
    getUrbanRegionalGeneralIndexReport(excelObjectData);
  }


  //get years
  const getAllYears = () => {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];
    for (let year = currentYear; year >= 2010; year--) {
      yearsArray.push(year);
    }
    return yearsArray;
  };

  return (
    <>
      <ToastContainer />
      <GlobalLoading />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.RURAL_REGIONAL_GENERAL_REPORT : priceTitle.en.RURAL_REGIONAL_GENERAL_REPORT }} />
              </h4>
              <div className="row align-items-center">

                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                  <label>  Select Year Range </label>

                  <select name="fromDate"
                    className="form-select"
                    onChange={handleOnChange}
                    value={fromDate}
                  >
                    <option value="" disabled>[---Select--]</option>
                    {getAllYears().map((ele, index) => (
                      <option key={index} value={ele}>
                        {ele}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                  To
                  <select
                    name="toDate"
                    className="form-select"
                    onChange={handleOnChange}
                    value={toDate}
                  >
                    <option value="" disabled>[---Select--]</option>
                    {getAllYears().map((ele, index) => (
                      <option key={index} value={ele}>
                        {ele}
                      </option>
                    ))}
                  </select>

                </div>



                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                  <label> Select Report Year</label>

                  <select
                    name="report_type"
                    className="form-select"
                    onChange={handleOnChange}
                    value={reportType}
                  >
                    <option value="" disabled>[---Select--]</option>
                    <option value="Agriculture Year">Agriculture Year</option>
                    <option value="Financial Year">Financial Year</option>
                  </select>

                </div>
                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                  <label> Select Group</label>

                  <select
                    name="group_type"
                    className="form-select"
                    onChange={handleOnChange}
                    value={groupType}
                  >
                    <option value="" disabled>[---Select--]</option>
                    <option value="All">Region Wise</option>
                    <option value="Major Group">Major Group</option>
                  </select>

                </div>




                <div className="col-xl-2 col-lg-4 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default RuralRegionalGeneralIndex